import { AnimatePresence } from 'framer-motion'
import { useAtom } from 'jotai'
import React from 'react'
import useBreakpoint from 'src/common/hooks/ui/useBreakpoint'
import Fade from 'src/common/ui-kit/Animations/Fade'
import { editOfferAtom } from 'src/pages/DiscoverPage/discover-store'
import EditOfferForm from './EditOfferForm'
import EditOfferModal from './EditOfferModal'

interface EditOfferProps {
  onSuccessfulEdit?: () => void
}

const EditOffer: React.FC<EditOfferProps> = ({ onSuccessfulEdit }) => {
  const [editOffer, setEditOffer] = useAtom(editOfferAtom)
  const is2xl = useBreakpoint('2xl')

  const handleClose = () => setEditOffer({ offer: null, open: false })

  if (is2xl) {
    return (
      <EditOfferModal
        open={editOffer.open}
        offer={editOffer.offer}
        onClose={handleClose}
        onSuccessfulEdit={onSuccessfulEdit}
      />
    )
  }

  return (
    <AnimatePresence>
      {editOffer.offer && (
        <Fade scale={0.9}>
          <div className='paper rounded-md p-4'>
            <EditOfferForm
              offer={editOffer.offer}
              onClose={handleClose}
              onSuccessfulEdit={onSuccessfulEdit}
            />
          </div>
        </Fade>
      )}
    </AnimatePresence>
  )
}

export default EditOffer
